/* ==========================================================================
   TP · YORUMLAR — yatay şerit göstergesi

   Şerit artık HER GENİŞLİKTE yatay kaydırılıyor, bu yüzden davranış
   medya sorgusuna DEĞİL şeridin gerçekten taşıp taşmadığına bağlı:
   `scrollWidth > clientWidth`. Kart sayısı azsa (ör. 2 kart, geniş ekran)
   şerit taşmaz ve noktalar kendiliğinden gizlenir — genişlik eşiği
   uydurmaya gerek kalmaz.

   KURALLAR:
   - Bölüm sayfada yoksa hiçbir şey yapma, hata verme.
   - OTOMATİK OYNATMA YOK (WCAG 2.2.2 — durdurulamayan hareket yasak).
   - Tüm yorumlar sayfası (.tp-tst--all) kaydırılmaz; orada şerit taşmaz,
     dolayısıyla bu dosya oraya da yüklense sessizce devre dışı kalır.
   ========================================================================== */

(function () {
  'use strict';

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function scrollBehavior() {
    return reducedMotion() ? 'auto' : 'smooth';
  }

  function init(root) {
    if (!root || root.getAttribute('data-tst-ready') === '1') return;

    var grid = root.querySelector('[data-tst-grid]');
    var dotsEl = root.querySelector('[data-tst-dots]');
    if (!grid || !dotsEl) return;

    root.setAttribute('data-tst-ready', '1');

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-tst-item]'));
    var observer = null;
    var resizeTimer = null;

    function isScrollable() {
      return grid.scrollWidth - grid.clientWidth > 4;
    }

    function setActiveDot(index) {
      var dots = dotsEl.querySelectorAll('.tp-tst__dot');
      for (var i = 0; i < dots.length; i++) {
        dots[i].setAttribute('aria-current', i === index ? 'true' : 'false');
      }
    }

    function observe() {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      if (!('IntersectionObserver' in window) || !items.length) return;

      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) setActiveDot(items.indexOf(entry.target));
          });
        },
        { root: grid, threshold: 0.6 }
      );

      items.forEach(function (li) {
        observer.observe(li);
      });
    }

    function buildDots() {
      dotsEl.textContent = '';

      if (!isScrollable() || items.length < 2) {
        dotsEl.hidden = true;
        if (observer) {
          observer.disconnect();
          observer = null;
        }
        return;
      }

      dotsEl.hidden = false;
      var tpl = dotsEl.getAttribute('data-tst-dot-tpl');

      items.forEach(function (li, i) {
        var wrap = document.createElement('li');
        var button = document.createElement('button');

        button.type = 'button';
        button.className = 'tp-tst__dot';
        button.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        button.setAttribute('aria-label', tpl ? tpl.replace('__n__', i + 1) : String(i + 1));
        button.addEventListener('click', function () {
          li.scrollIntoView({ inline: 'center', block: 'nearest', behavior: scrollBehavior() });
        });

        wrap.appendChild(button);
        dotsEl.appendChild(wrap);
      });

      observe();
    }

    function sync() {
      var label = grid.getAttribute('data-tst-carousel-label');

      // Rol HER ZAMAN `list` kalır (1 Eki 2026). Eskiden kaydırılabilirken
      // `region` yapılıyordu: <li>'ler liste ebeveynini kaybediyor, Lighthouse
      // "listitem" denetiminden 5 hata veriyordu. Klavyeyle kaydırma için
      // gereken yalnız odaklanabilirlik + ad; liste rolü ikisini de taşır.
      if (isScrollable()) {
        grid.setAttribute('tabindex', '0');
        if (label) grid.setAttribute('aria-label', label);
      } else {
        grid.removeAttribute('tabindex');
        grid.removeAttribute('aria-label');
      }

      buildDots();
    }

    grid.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      if (!isScrollable()) return;

      event.preventDefault();
      var step = grid.clientWidth * 0.8;
      grid.scrollBy({ left: event.key === 'ArrowRight' ? step : -step, behavior: scrollBehavior() });
    });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(sync, 200);
    });

    sync();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('.tp-tst');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
